import { useContext } from 'react';
import { ActionDispatcherContext } from 'providers';

function useActionDispatcher() {
  return useContext(ActionDispatcherContext);
}

export { useActionDispatcher };
